<div class="alignment">
  <button mat-icon-button
          [class.active]="alignment === textAlignment.Start"
          (click)="setAlignment(textAlignment.Start)"
  >
    <img src="/assets/img/text-editor/align-left.svg"/>
  </button
  ><button mat-icon-button
           [class.active]="alignment === textAlignment.Middle"
           (click)="setAlignment(textAlignment.Middle)"
  >
    <img src="/assets/img/text-editor/align-center.svg"/>
  </button
  ><button mat-icon-button
           [class.active]="alignment === textAlignment.End"
           (click)="setAlignment(textAlignment.End)"
  >
    <img src="/assets/img/text-editor/align-right.svg"/>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/text-editing/text-alignment-chooser.component.html